import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { take } from "rxjs/operators";
import { Agent } from "../models/consts/agents.static-data";
import { STATIC_DATA_TYPE } from "../models/consts/static-data.enum";
import { StaticDataService } from "./static-data.service";

@Injectable({
    providedIn: 'root'
})
export class AgentStaticDataService {

    private _agents$ = new ReplaySubject<Agent[]>();

    agents$ = this._agents$.asObservable();

    constructor(private staticDataService: StaticDataService) {

        this.staticDataService.getData(STATIC_DATA_TYPE.AGENTS)
            .pipe(
                take(1)
            )
            .subscribe((data: Agent[]) => this._agents$.next(data));

    }

}